import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DialogTitle from '@material-ui/core/DialogTitle';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Divider, FormControl, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import { FormGroup } from '@material-ui/core';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
});
const swal = withReactContent(Swal)


export default class NewLecture extends React.Component {
  constructor(props){
    super(props)
    this.state ={
      title : '',
      editor: 'ory',
      qualifications : [],
      qlist : ['NFS','RA','RS','RH']
    }
  }

  handleEditorChange = (event) => {
    console.log(event.target.value)
    this.setState({editor:event.target.value})
  };

  handleQualiChange = (val) => {
    const quali = this.state.qualifications
    if (quali.indexOf(val) !== -1) {
      console.log('rem',val,quali)
      this.setState({qualifications: quali.filter(v => v !== val)})
    }
    else {
      console.log('add',val,quali)
      this.setState({qualifications: [...quali,val]})
    }
  }

render () {
  const {qualifications} = this.state
  return (
    <div>
<Dialog
  maxWidth='lg'
  fullWidth
  open={this.props.open}
  onClose={this.props.onClose}
  aria-labelledby="form-dialog-title"
  disableBackdropClick={false}
>
  <DialogTitle id="form-dialog-title">Titel</DialogTitle>
  <DialogContent>
    <TextField
       label="Titel"
       onChange = {(e) => this.setState({title:e.target.value})}
     />
     <Divider/>
     <FormControl component="fieldset">
       <FormLabel>Qualifikationen</FormLabel>
       <FormGroup row>
       <FormControlLabel control={<Checkbox value={'all'} checked={qualifications.length == this.props.qlist.length} onChange={e => this.setState({qualifications:this.props.qlist})} color="primary" name={'qlist'}/>} label='Alle' />
         {this.props.qlist && this.props.qlist.map((q,i) => 
        <FormControlLabel key={'qua'+i} control={<Checkbox value={q} checked={qualifications.indexOf(q) !== -1} onChange={e => this.handleQualiChange(e.target.value)} color="primary" name={'qlist'}/>} label={q} />
        )}
        </FormGroup>
      </FormControl>
     <Divider/>
     <div style={{width:'100%'}}>
      <FormControl component="fieldset">
        <FormLabel>Editor</FormLabel>
        <RadioGroup value={this.state.editor} onChange={this.handleEditorChange}>
        <FormControlLabel value="ory" control={<Radio color="primary" />} label="Editor für gute Darstellung am Desktop und Handy" />
         <FormControlLabel value="tinymce" control={<Radio color="primary" />} label="Word-ähnlicher Editor. Macht nur am Desktop gute Seiten" />
         <FormControlLabel value="video" control={<Radio color="primary" />} label="Video-Fortbildung" />
      </RadioGroup>
      </FormControl>
      </div>
    </DialogContent>
  <DialogActions>
     <Button variant="contained" color="primary" primary='true' onClick={(event) => this.props.createNewLecture({title:this.state.title,editor:this.state.editor,qualifications:this.state.qualifications})}>
     Absenden
     </Button>
  </DialogActions>
</Dialog>
</div>
)
}
}
